const initCursorSmoke = () => {
  if (window.matchMedia('(pointer: coarse)').matches) {
    return
  }

  if (document.querySelector('.drift-smoke-layer') || document.querySelector('.drift-smoke-core')) {
    return
  }

  const smokeLayer = document.createElement('div')
  smokeLayer.className = 'drift-smoke-layer'

  const smokeCore = document.createElement('div')
  smokeCore.className = 'drift-smoke-core'

  document.body.appendChild(smokeLayer)
  document.body.appendChild(smokeCore)

  const poolSize = 18
  const puffs = []
  const active = []

  for (let i = 0; i < poolSize; i += 1) {
    const el = document.createElement('div')
    el.className = 'drift-smoke-puff'
    smokeLayer.appendChild(el)
    puffs.push({
      el,
      active: false,
      x: -100,
      y: -100,
      vx: 0,
      vy: 0,
      life: 0,
      age: 0,
      scale: 0.3,
      opacity: 0
    })
  }

  let mouseX = window.innerWidth * 0.5
  let mouseY = window.innerHeight * 0.5
  let targetX = mouseX
  let targetY = mouseY
  let lastX = mouseX
  let lastY = mouseY
  let lastSpawnAt = 0
  let rafId = 0

  const spawnPuff = (power, vx, vy) => {
    const puff = puffs.find((item) => ! item.active) || puffs[0]
    puff.active = true
    puff.age = 0
    puff.life = 420 + power * 220
    puff.scale = 0.35 + power * 0.95
    puff.opacity = 0.12 + power * 0.28
    puff.x = mouseX - vx * 10 - 18
    puff.y = mouseY - vy * 10 - 18
    puff.vx = vx * (12 + power * 10) + (Math.random() - 0.5) * 0.7
    puff.vy = vy * (12 + power * 10) + (Math.random() - 0.5) * 0.7 - (0.2 + power * 0.4)

    if (! active.includes(puff)) {
      active.push(puff)
    }
  }

  const updateSmoke = (now) => {
    mouseX += (targetX - mouseX) * 0.22
    mouseY += (targetY - mouseY) * 0.22

    smokeCore.style.opacity = '1'
    smokeCore.style.transform = `translate3d(${mouseX - 7}px, ${mouseY - 7}px, 0)`

    const dx = targetX - lastX
    const dy = targetY - lastY
    const velocity = Math.hypot(dx, dy)
    lastX = targetX
    lastY = targetY

    const normalized = Math.min(velocity / 42, 1)
    const spawnDelay = normalized > 0.7 ? 18 : normalized > 0.35 ? 32 : 58

    if (velocity > 1.2 && now - lastSpawnAt > spawnDelay) {
      const directionX = velocity ? dx / velocity : 0
      const directionY = velocity ? dy / velocity : 0
      const copies = velocity > 30 ? 3 : velocity > 16 ? 2 : 1

      for (let i = 0; i < copies; i += 1) {
        spawnPuff(normalized, directionX, directionY)
      }

      lastSpawnAt = now
    }

    for (let i = active.length - 1; i >= 0; i -= 1) {
      const puff = active[i]
      puff.age += 16

      if (puff.age >= puff.life) {
        puff.active = false
        puff.el.style.opacity = '0'
        puff.el.style.transform = 'translate3d(-100px, -100px, 0) scale(0.3)'
        active.splice(i, 1)
        continue
      }

      const progress = puff.age / puff.life
      const fade = 1 - progress
      puff.x -= puff.vx
      puff.y -= puff.vy

      puff.el.style.opacity = String(puff.opacity * fade)
      puff.el.style.transform = `translate3d(${puff.x}px, ${puff.y}px, 0) scale(${puff.scale + progress * 0.9})`
    }

    rafId = window.requestAnimationFrame(updateSmoke)
  }

  window.addEventListener('mousemove', (event) => {
    targetX = event.clientX
    targetY = event.clientY
  }, { passive: true })

  window.addEventListener('mouseleave', () => {
    smokeCore.style.opacity = '0'
  })

  window.addEventListener('mouseenter', () => {
    smokeCore.style.opacity = '1'
  })

  rafId = window.requestAnimationFrame(updateSmoke)

  window.addEventListener('beforeunload', () => {
    window.cancelAnimationFrame(rafId)
  })
}

export default initCursorSmoke



// WEBPACK FOOTER //
// ./resources/assets/js/components/cursor-smoke.js